<div class="row">
  <div class="col-md-4">
    <mat-form-field class="col-sm-12">
      <input matInput placeholder="Identificador:" [value]="employeeRef.employeeNumber" type="text" disabled>
    </mat-form-field>
  </div>
  <div class="col-md-4">
    <mat-form-field class="col-sm-12">
      <input matInput placeholder="Nombre:" [value]="employeeRef.displayName" type="text" disabled>
    </mat-form-field>
  </div>
  <div class="col-md-4">
    <mat-form-field class="col-sm-12">
      <input matInput placeholder="Correo Electrónico:" [value]="employeeRef.email" type="text" disabled>
    </mat-form-field>
  </div>
</div>